var exit_intent_popup = ( function( $ ) {

	var $body,
		$popup,
		open = false,
		last_position,
		delta;

	var _init = function() {
		$body  = $( 'body' );
		$popup = $( '#crate-exit-intent-popup' );

		if ( $popup.length > 0 ) {
			_setup_triggers();

			// Using a mobile device
			$( document ).on( 'touchstart', function() {
				$( document ).on( 'scroll', _check_scroll_speed );
			} );

			$( document ).keyup( function( e ) {
				if ( e.key === "Escape" ) {
					if ( open ) {
						_close_popup();
					}
				}
			} );

			// $popup.find('.image img').lazy({
			// 	bind: "exit-intent-popup-open"
			// });
		}
	};

	var _setup_triggers = function() {
		$( document ).on( 'mouseout', _setup_exit_intent_listener );

		$popup.on( 'click', function( e ) {
			if ( ! $( e.target ).hasClass( 'exit' ) && ! $( e.target ).hasClass( 'crate-popup-wrap' ) ) {
				e.stopImmediatePropagation();
			}
		} );

		$popup.find( 'exit', function( e ) {
			_close_popup( e );
		} );

		$popup.closest( '.crate-popup-wrap' ).on( 'click', _close_popup );
	};

	var _setup_exit_intent_listener = function ( e )  {
		// If the mouse is near the top of the window, show the popup Also, do not trigger when hovering or clicking on selects bug in firefox
		if ( e.clientY < 50 && e.relatedTarget == null && e.target.nodeName.toLowerCase() !== 'select' ) {
			// Remove this event listener
			$( document ).off( 'mouseout', _setup_exit_intent_listener );

			// Show the popup
			_open_popup();
		}
	};

	var _check_scroll_speed = function() {
		if ( _user_scroll() < -150 ) {
			_open_popup();
		}
	};

	var _clear_last_delta = function(  ) {
		last_position = null;
		delta = 0;
	};

	var _check_delta = function() {
		var	new_position,
			timer,
			delay = 50;

		new_position = window.scrollY;

		if ( last_position != null ) {
			delta = new_position - last_position;
		}

		last_position = new_position;

		clearTimeout( timer );

		timer = setTimeout( _clear_last_delta, delay );

		return delta;
	};

	var _user_scroll = function() {
		return _check_delta();
	};

	var _open_popup = function() {
		if ( _has_seen_popup() ) {
			return;
		}

		$( 'body' ).addClass( 'open-popup' );
		$popup.closest( '.crate-popup-wrap' ).fadeIn();
		$popup.trigger( 'exit-intent-popup-open' );

		// Force the lazy image to load
		var instance = $popup.find('.ajax-loader img').data("plugin_lazy");
		instance.force('.ajax-loader img');

		_set_cookie();

		open = true;
	};

	var _close_popup = function( e ) {
		if ( e ) {
			e.preventDefault();
		}

		$( 'body' ).removeClass( 'open-popup' );
		$popup.closest( '.crate-popup-wrap' ).fadeOut();

		open = false;
	};

	var _set_cookie = function() {
		$.cookie( 'exit_intent_seen', 'true' );
	};

	var _has_seen_popup = function() {
		return 	$.cookie( 'exit_intent_seen' );
	};

	$( document ).ready( _init );

} )( jQuery );

module.exports = exit_intent_popup;